export default "__VITE_ASSET__d851af6b__"